import React from "react";
import { 
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, Loader2 } from "lucide-react";
import { IconSelector } from "./IconSelector";

interface CreateCategoryDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  newCategoryName: string;
  newCategoryIcon: string;
  setNewCategoryName: (name: string) => void;
  setNewCategoryIcon: (icon: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  isPending: boolean;
  resetForm: () => void;
}

const CreateCategoryDialog = ({
  isOpen,
  onOpenChange,
  newCategoryName,
  newCategoryIcon,
  setNewCategoryName,
  setNewCategoryIcon,
  onSubmit,
  isPending,
  resetForm,
}: CreateCategoryDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Add New Category</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit}>
          <div className="space-y-6 py-4">
            <div className="space-y-2">
              <Label htmlFor="name">Name *</Label>
              <Input
                id="name"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                placeholder="Category name"
                required
              />
            </div>
            
            <div className="space-y-2">
              <Label>Icon *</Label>
              <IconSelector
                value={newCategoryIcon}
                onChange={setNewCategoryIcon}
                placeholder="Choose an icon for this category"
              />
            </div>
          </div>
          
          <DialogFooter className="mt-6">
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => {
                onOpenChange(false);
                resetForm();
              }}
            >
              Cancel
            </Button>
            <Button 
              type="submit" 
              disabled={isPending || !newCategoryName.trim() || !newCategoryIcon.trim()}
            >
              {isPending ? (
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              ) : (
                <Plus className="h-4 w-4 mr-2" />
              )}
              Add Category
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CreateCategoryDialog;
